var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFleetyardsRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 356 c-83 -50 -112 -162 -64 -247 26 -48 49 -50 90 -9 l30 31 -5 -28 c-3 -15 -9 -41 -13 -57 -5 -21 -4 -28 6 -24 24 8 38 72 39 176 1 61 5 102 11 102 6 0 10 -41 11 -102 1 -104 15 -168 39 -176 9 -3 11 3 6 24 -3 16 -8 45 -11 64 -4 28 -4 31 4 14 11 -26 49 -54 71 -54 27 0 60 72 60 130 0 105 -75 180 -181 180 -39 0 -65 -7 -93 -24z m104 -26 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 80 c-13 -11 -18 -20 -12 -20 6 0 14 0 18 -1 4 0 10 9 15 20 9 25 9 25 -21 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 80 c7 -25 15 -31 30 -22 7 5 3 13 -12 24 -22 17 -23 17 -18 -2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetyardsRound);
export default __webpack_public_path__ + "static/media/fleetyards-round.914f45528db8188ab800d08928c67603.svg";
export { ForwardRef as ReactComponent };